export const faqs = [
    {
        question: "Does IndusInd Bank accept loan settlement?",
        answer:
            "Yes, IndusInd Bank accepts loan settlement (One Time Settlement or OTS) for borrowers who are genuinely unable to repay their loans due to financial hardships like job loss, medical emergencies, or business failure. This is typically offered when the loan has become a Non-Performing Asset (NPA).",
    },
    {
        question: "How can I settle my IndusInd Bank Credit Card debt?",
        answer:
            "To settle your IndusInd Bank Credit Card dues, you typically need to be in default for more than 90 days. Once the bank or its recovery agencies initiate collection, you can negotiate for a settlement. It involves paying a lump sum amount (often less than the total outstanding) to close the account. Professional negotiation can help reduce the settlement amount significantly.",
    },
    {
        question: "Will settling my IndusInd Bank loan affect my CIBIL score?",
        answer:
            "Yes, opting for a settlement will negatively impact your credit score. IndusInd Bank will report the account status as 'Settled' to credit bureaus (CIBIL, Experian, etc.), which indicates that the loan was not paid in full. This can lower your score by 50-100 points, but it stops the ongoing damage of a 'Written Off' status.",
    },
    {
        question: "Can IndusInd Bank file a legal case against me for non-payment?",
        answer:
            "Yes, IndusInd Bank has the right to initiate legal proceedings. This can include filing a civil suit for recovery, or in cases of bounced cheques/ECS, a criminal case under Section 138 of the Negotiable Instruments Act. They may also initiate arbitration. It is advisable to seek legal counsel if you receive such notices.",
    },
    {
        question: "What is the minimum settlement amount IndusInd Bank accepts?",
        answer:
            "There is no fixed minimum, as it depends on the type of loan (unsecured vs. secured), the duration of default, and your proven financial hardship. Generally, settlements can range from 30% to 50% of the principal plus interest, but skilled negotiators can sometimes achieve better terms.",
    },
    {
        question: "How do I get a settlement letter from IndusInd Bank?",
        answer:
            "After negotiating the settlement amount, you must request a formal Settlement Letter from IndusInd Bank. This document should clearly state the agreed settlement amount, the deadline for payment, and a clause stating that upon payment, the loan will be closed with no further dues. Never make a payment based on a verbal agreement.",
    },
];
